<template>
  <v-container fluid class="pa-0">
    <breadcrumbs-banner :bannerTitle="$t('header.faq')"></breadcrumbs-banner>
  </v-container>
</template>
<script>
export default {
  name: "fqa",
};
</script>
